module.exports = __webpack_public_path__ + "assets/img/待付款.fa71b6fb.svg";